import axios from '../axios'
import { IGetAllData, IGetAllParams } from './eigenvalue.types'

/**
 * 十五个特征值
 */
export function getAll(params: IGetAllParams) {
    return axios<IGetAllData>({
        method: 'get',
        url: '/eigenvalue/getAll',
        params
    })
}
